export default function onAccordionClick(event: MouseEvent): void {
  let target = event.target as HTMLElement;

  // Traverse up to find the closest anchor element
  while (target && target.tagName !== "A") {
    target = target.parentElement as HTMLElement;
  }

  if (!target || !target.classList.contains("cs-accordion-anchor")) {
    return;
  }

  event.preventDefault();

  const href = target.getAttribute("href");
  if (!href) return;

  const className = href.replace("#", ".");

  // If the clicked anchor was already active, close its associated content and remove active class
  if (target.classList.contains("active")) {
    target.classList.remove("active");
    const graphElementsToToggle = document.querySelectorAll(className);
    graphElementsToToggle.forEach((el) => el.classList.add("hidden"));
    return; // Exit early
  }

  // Close all accordion content elements
  const allAccordionContents = document.querySelectorAll(".cs-accordion-panel");
  allAccordionContents.forEach((content) => {
    content.classList.add("hidden");
  });

  // Remove active class from all accordion anchors
  const allAccordionAnchors = document.querySelectorAll(".cs-accordion-anchor");
  allAccordionAnchors.forEach((anchor) => {
    anchor.classList.remove("active");
  });

  // Open the associated content of the clicked anchor and set it as active
  target.classList.add("active");
  const graphElementsToToggle = document.querySelectorAll(className);
  if (graphElementsToToggle.length > 1) {
    target.nextElementSibling?.classList.remove("hidden");
  } else {
    document.querySelector(href)?.classList.remove("hidden");
  }
}

export function onFitToProfileGraphClick(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  const classNames = ["leaderTypeFitGraphArea", "leaderTypeFitGraphLabel", "leaderTypeGraphBar"];
  const clickedAccordianTarget = classNames.some((className) =>
    target.classList.contains(className),
  );
  if (clickedAccordianTarget) {
    onAccordionClick(event);
  }
}

export function onLeaderTypeTitleClick(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  const clickedLeaderTypeTitle =
    target.classList.contains("showPopover") && target.parentElement?.tagName === "H3";
  if (clickedLeaderTypeTitle) {
    const tooltipText = target.getAttribute("data-content");
    if (tooltipText) {
      target.setAttribute("title", tooltipText);
    }
  }
}

export function onDiamondButtonHover(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  const clickedDiamondButton = target.classList.contains("diamondButton-circular");
  if (clickedDiamondButton) {
    let tooltipText = target.parentElement?.getAttribute("data-leadertypecssname");
    if (tooltipText) {
      tooltipText = tooltipText.charAt(0).toUpperCase() + tooltipText.slice(1);
      target.setAttribute("title", tooltipText);
    }
  }
}
